import { ApiClientsLastActivityActive } from 'pages/ApiClients/components/ApiClientsLastActivityField/ApiClientsLastActivityActive';
import { ApiClientsLastActivityInactive } from 'pages/ApiClients/components/ApiClientsLastActivityField/ApiClientsLastActivityInactive';
import { FunctionField } from 'shared/react-admin/Fields';
import { ApiClient } from 'types/embedded/apiClient';

type Props = {
  label: string;
  source?: string;
  sortBy?: string;
};

export const ApiClientsLastActivityField: React.FC<Props> = ({ label, sortBy }) => {
  return (
    <FunctionField
      label={label}
      render={({
        active,
        activityUpdatedAtColor,
        activityUpdatedAtMessage,
        activityUpdatedAt,
      }: ApiClient) => {
        return active ? (
          <ApiClientsLastActivityActive
            activityUpdatedAtColor={activityUpdatedAtColor}
            activityUpdatedAtMessage={activityUpdatedAtMessage}
          />
        ) : (
          <ApiClientsLastActivityInactive activityUpdatedAt={activityUpdatedAt} />
        );
      }}
      sortBy={sortBy}
    />
  );
};
